import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="DMVRapChat - Your guide to navigating DMV services" 
          className="hero-image" 
        />
        <p className="eyebrow">DMVRapChat</p>
        <h1>Stay Updated on All Things DMV</h1>
        <p className="lede">
          Your go-to source for the latest DMV news and updates, keeping you informed and empowered.
        </p>
        <div className="cta-row">
          <a href="/guides" className="primary">
            Explore Our Guides
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Step-by-Step DMV Guides</h2>
          <p>
            Access comprehensive guides that walk you through every DMV process, ensuring you have the information you need at your fingertips.
          </p>
        </article>
        <article>
          <h2>Frequently Asked Questions</h2>
          <p>
            Find answers to common DMV inquiries, helping you save time and avoid confusion.
          </p>
        </article>
        <article>
          <h2>Latest DMV News</h2>
          <p>
            Stay updated on the latest changes in DMV regulations and services to keep your knowledge current.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;